
export const pricing = {
  'request.pricing': 'בקש הצעת מחיר',
  'view.pricing': 'צפה במחירים',
  'product.pricing': 'תמחור מוצר',
};
